import { useEffect, useId, useRef, type ReactNode } from "react";
import { createPortal } from "react-dom";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { useLocale } from "../i18n";
import "../styles/invitation-review.css";

export function InvitationReviewDialog({title,locked,onClose,children,className=""}:{title:string;locked:boolean;onClose:()=>void;children:ReactNode;className?:string}) {
  const {w}=useLocale();const id=useId();const dialog=useRef<HTMLDialogElement>(null);
  useEffect(()=>{const node=dialog.current;node?.showModal();return()=>node?.close();},[]);
  return createPortal(<dialog ref={dialog} className={`action-dialog event-invitation-review ${className}`} aria-labelledby={id}
    onCancel={event=>{event.preventDefault();if(!locked)onClose();}}>
    <header className="dialog-header"><h2 id={id}>{title}</h2><button type="button" className="icon-button" aria-label={w("إغلاق","Close")} disabled={locked} onClick={onClose}><XMarkIcon aria-hidden="true"/></button></header>
    <div className="event-invitation-review-content">{children}</div>
  </dialog>,document.body);
}
